import { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";

const HINTS = {
  English: ["Ask me anything. Type below or tap the mic to speak.", "Message…", "Listening…"],
  Hindi: ["कुछ भी पूछें। नीचे लिखें या बोलने के लिए माइक दबाएँ।", "संदेश लिखें…", "सुन रहा हूँ…"],
  Hinglish: ["Kuch bhi poochho. Neeche likho ya mic dabao aur bolo.", "Message likho…", "Sun raha hoon…"],
};

export const MessageList = ({ messages, thinking, botName, lang = "English" }) => {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages, thinking]);

  return (
    <main data-testid="chat-message-list" className="flex-1 overflow-y-auto px-4 sm:px-6 py-6 space-y-4">
      {messages.length === 0 && (
        <div data-testid="chat-empty-state" className="h-full grid place-items-center text-center px-6">
          <div>
            <p className="text-2xl sm:text-3xl font-semibold text-slate-900 tracking-tight">Hi, I'm {botName || "here"}.</p>
            <p className="mt-2 text-sm text-slate-500">{HINTS[lang][0]}</p>
          </div>
        </div>
      )}
      {messages.map((m, i) =>
        m.role === "user" ? (
          <div key={i} className="flex justify-end rise">
            <div data-testid="chat-user-message-bubble" className="bg-slate-800 text-white px-4 py-2.5 rounded-2xl rounded-tr-sm max-w-[85%] sm:max-w-[75%] text-sm sm:text-[15px] leading-relaxed whitespace-pre-wrap break-words">
              {m.content}
            </div>
          </div>
        ) : m.error ? (
          <div key={i} className="flex justify-start rise">
            <div data-testid="chat-error-bubble" className="bg-red-50 text-red-700 border border-red-200 px-4 py-2.5 rounded-2xl rounded-tl-sm max-w-[92%] sm:max-w-[80%] text-sm leading-relaxed break-words">
              Sorry, I couldn't answer that. {m.content}
            </div>
          </div>
        ) : (
          <div key={i} className="flex justify-start rise">
            <div data-testid="chat-ai-message-bubble" className="md bg-white text-slate-900 border border-slate-200 px-4 py-3 rounded-2xl rounded-tl-sm max-w-[92%] sm:max-w-[80%] text-sm sm:text-[15px] leading-relaxed break-words">
              <ReactMarkdown>{m.content}</ReactMarkdown>
              {m.sources?.length > 0 && (
                <p data-testid="chat-sources" className="mt-2 pt-2 border-t border-slate-100 text-[11px] text-slate-400 leading-snug">
                  Sources: {[...new Set(m.sources.map((s) => s.name.replace(/\.[^.]+$/, "")))].join(", ")} · {m.sources.length} passages
                </p>
              )}
            </div>
          </div>
        )
      )}
      {thinking && (
        <div className="flex justify-start rise">
          <div data-testid="thinking-indicator" className="bg-white border border-slate-200 px-4 py-3 rounded-2xl rounded-tl-sm flex items-center gap-2 text-sm text-slate-500">
            <span className="flex gap-1"><span className="dot" /><span className="dot" /><span className="dot" /></span>
            Thinking…
          </div>
        </div>
      )}
      <div ref={endRef} />
    </main>
  );
};
